var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.25H5.25C5.05109 9.25 4.86032 9.17098 4.71967 9.03033C4.57902 8.88968 4.5 8.69891 4.5 8.5C4.5 8.30109 4.57902 8.11032 4.71967 7.96967C4.86032 7.82902 5.05109 7.75 5.25 7.75H18.75C18.9489 7.75 19.1397 7.82902 19.2803 7.96967C19.421 8.11032 19.5 8.30109 19.5 8.5C19.5 8.69891 19.421 8.88968 19.2803 9.03033C19.1397 9.17098 18.9489 9.25 18.75 9.25ZM16.25 12.75H7.75C7.55109 12.75 7.36032 12.671 7.21967 12.5303C7.07902 12.3897 7 12.1989 7 12C7 11.8011 7.07902 11.6103 7.21967 11.4697C7.36032 11.329 7.55109 11.25 7.75 11.25H16.25C16.4489 11.25 16.6397 11.329 16.7803 11.4697C16.921 11.6103 17 11.8011 17 12C17 12.1989 16.921 12.3897 16.7803 12.5303C16.6397 12.671 16.4489 12.75 16.25 12.75ZM13.25 16.25H10.75C10.5511 16.25 10.3603 16.171 10.2197 16.0303C10.079 15.8897 10 15.6989 10 15.5C10 15.3011 10.079 15.1103 10.2197 14.9697C10.3603 14.829 10.5511 14.75 10.75 14.75H13.25C13.4489 14.75 13.6397 14.829 13.7803 14.9697C13.921 15.1103 14 15.3011 14 15.5C14 15.6989 13.921 15.8897 13.7803 16.0303C13.6397 16.171 13.4489 16.25 13.25 16.25Z",
    fill: "#505762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2c0a0084b7b7491030dcca57111eed4d.svg";
export { ForwardRef as ReactComponent };